if (!customElements.get('product-modal')) {
  customElements.define('product-modal', class ProductModal extends ModalDialog {
    constructor() {
      super();
      this.loaded = false;
      this._bindGalleryInteraction();
    }

    _bindGalleryInteraction() {
      const gallery = document.querySelector('product-gallery');
      if (!gallery) return;

      const loadModalImages = () => this._loadImages();
      gallery.addEventListener('mouseenter', loadModalImages, { once: true });
      gallery.addEventListener('mousemove', loadModalImages, { once: true });
      gallery.addEventListener('click', loadModalImages, { once: true });
    }

    _loadImages() {
      if (this.loaded) return;
      this.loaded = true;
      const modalContent = this.querySelector('.product-media-modal__content');
      if (!modalContent) return;

      this.querySelectorAll('template[data-media-id]').forEach(template => {

        const matches = template.dataset.mediaId.match(/(\d+)$/);
        if (!matches) return;
        const mediaId = matches[1];

        if (!modalContent.querySelector(`.media-wrapper[data-media-id="${mediaId}"]`)) {
          const clone = template.content.cloneNode(true);
          modalContent.appendChild(clone);
        }
      });
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      this._loadImages();
      super.show(opener);
      this.showActiveMedia();
      this._autoplayActiveVideo();
      this._prepareFirstVideoSilently();
    }

    showActiveMedia() {
      const activeMediaId = this.openedBy?.getAttribute("data-media-id");
      if (!activeMediaId) return;

      this.querySelectorAll(`[data-media-id]:not([data-media-id="${activeMediaId}"])`).forEach((element) => {
        element.classList.remove('is-active');
      });

      let activeMedia = this.querySelector(`[data-media-id="${activeMediaId}"]`);
      if (!activeMedia) {
        activeMedia = Array.from(this.querySelectorAll('[data-media-id]')).find(el => {
          const id = el.getAttribute('data-media-id');
          return id && id.endsWith('-' + activeMediaId);
        });
      }
      if (!activeMedia) return;

      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('is-active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      if (container && activeMedia.width) {
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;
      }

      if (
        activeMedia.nodeName == 'DEFERRED-MEDIA' &&
        activeMediaContent &&
        activeMediaContent.querySelector('.js-youtube')
      ) {
        activeMedia.loadContent();
      }
    }

    _findWrapperByMediaId(id) {
      let el = this.querySelector(`[data-media-id="${id}"]`);
      if (el) return el;
      return Array.from(this.querySelectorAll('[data-media-id]')).find(e => {
        const v = e.getAttribute('data-media-id');
        return v && v.endsWith('-' + id);
      });
    }

    _autoplayActiveVideo() {
      const id = this.openedBy?.getAttribute('data-media-id');
      if (!id) return;
      const wrapper = this._findWrapperByMediaId(id);
      if (!wrapper) return;

      const deferred = wrapper.querySelector('deferred-media');
      if (!deferred) return;

      if (!deferred.hasAttribute('loaded')) {
        if (typeof deferred.loadContent === 'function') {
          deferred.loadContent(false);
        }
      }
      const video = deferred.querySelector('video');
      if (!video) return;
      video.muted = true;
      video.setAttribute('playsinline','');
      video.setAttribute('autoplay','');
      video.play().catch(()=>{});
    }

    _prepareFirstVideoSilently() {
      const openerId = this.openedBy?.getAttribute('data-media-id');
      const content = this.querySelector('.product-media-modal__content');
      if (!content) return;
      if (content.querySelector('video')) return;

      const firstDeferred = Array.from(content.querySelectorAll('deferred-media')).find(dm => {
        const tpl = dm.querySelector('template');
        return tpl && tpl.content.querySelector('video');
      });
      if (!firstDeferred) return;

      const wrapper = firstDeferred.closest('[data-media-id]');
      if (wrapper) {
        const wid = wrapper.getAttribute('data-media-id');
        if (wid === openerId || (wid && wid.endsWith('-' + openerId))) {
          return;
        }
      }

      const saved = content.scrollTop;
      if (!firstDeferred.hasAttribute('loaded')) {
        if (typeof firstDeferred.loadContent === 'function') {
          firstDeferred.loadContent(false);
        }
      }
      setTimeout(() => {
        content.scrollTop = saved;
        const video = firstDeferred.querySelector('video');
        if (!video) return;
        video.muted = true;
        video.setAttribute('playsinline','');
        video.setAttribute('autoplay','');
        video.play().catch(()=>{});
      }, 80);
    }
  });
}
